// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/**
 * 获取字典数据
 */
export const getDict = async (type: string) => {
  return request<{
    success?: boolean;
    data?: any;
  }>(`/system/dict/data/list?dictType=${type}`, {
    method: "GET",
  });
};

/**
 * 获取商品类型字典
 */
export const getProductType = async () => {
  return getDict("product_type");
};

/**
 * 获取商品形状字典
 */
export const getProductShape = async () => {
  return getDict("product_shape");
};

/**
 * 获取商品状态字典
 */
export const getProductStatus = async () => {
  return getDict("product_status");
};

/**
 * 获取服务类型字典
 */
export const getServiceType = async () => {
  return getDict("service_type");
};

/**
 * 获取订单状态字典
 */
export const getOrderStatus = async () => {
  return getDict("order_status");
};

/**
 * 获取物流状态字典
*/
export const getShippingStatus = async () => {
  return getDict("shipping_status");
};

/**
 * 获取优惠券类型字典
 */
export const getCouponType = async () => {
  return getDict("coupon_type");
};

/**
 * 3. 退款状态字典
 */
export const getRefundStatus = async () => {
  return getDict("after_sale_status");
};

/**
 * 4.退款方案
 */
export const getRefundResolution = async () => {
  return getDict("after_sale_resolution");
};



/**
 * 产品列表
 */
export const qrcodeProduct = async () => {
  return request<{
    success?: boolean;
    data?: any;
  }>("/product/section", {
    method: "GET",
  });
};

/**
 * 获取appid
 */
export const getAppId = async () => {
  return request<{
    code?: number;
    msg?: string;
    data?: {
      appId: string;
    };
  }>("/lark/getAppId", {
    method: "GET",
    // @ts-ignore
    skipToken: true,
  });
};

/**
 * 登录回调
 */
export const getFeishuLogin = async (data: { code: string }) => {
  return request<{
    code?: number;
    msg?: string;
    data?: {
      token: string;
    };
  }>("/lark/login?code=" + data.code, {
    method: "GET",
    skipToken: true,
  });
};

// /**
//  * 下载日志
//  */
// export const addlog = async (data: {
//   businessId: string;
//   operationModule: string;
//   operationType: string;
//   operationContent: string;
// }) => {
//   return request<{
//     success?: boolean;
//     data?: any;
//   }>("/log/add", {
//     method: "POST",
//     data,
//   });
// };

/**
 * 上传文件
 */
export const uploadFile = async (data: { file: any }) => {
  return request<{
    code: number;
    data?: any;
  }>("/sys/oss/upload", {
    method: "POST",
    data,
  });
};
